export const CONTRACT_ADDRESS = "0xa03Ab7B9cE50fB91361674f2f6E71C4Be2b76948";
